/* eslint-disable react/jsx-no-target-blank */
import {AsideMenuItemWithSub} from './AsideMenuItemWithSub'
import {AsideMenuItem} from './AsideMenuItem'
import {useAuth} from '../../../../app/modules/auth'
import OperatorStockPanel from './OperatorStockPanel'

export function AsideMenuMain() {
  const {currentUser} = useAuth()

  const role = currentUser?.profile?.rol

  const isAdmin = role === 'admin' || role === 'superadmin'

  return (
    <>
      {isAdmin && (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>OPERACIONES</span>
            </div>
          </div>
        </>
      )}

      {isAdmin ? (
        <>
          <AsideMenuItem
            to='/operations/towels/delivery'
            icon='black-right'
            title='Entrega de Toallas'
            fontIcon='bi-box-arrow-in-right'
          />

          <AsideMenuItem
            to='/operations/towels/return'
            icon='black-right'
            title='Devolución de Toallas'
            fontIcon='bi-box-arrow-in-box-arrow-in-right'
          />

          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>GESTIÓN</span>
            </div>
          </div>

          <AsideMenuItem to='/management/towels' title='Toallas' hasBullet={true} />
          <AsideMenuItem to='/management/zones' title='Zonas' hasBullet={true} />
          <AsideMenuItem to='/management/users' title='Usuarios' hasBullet={true} />

          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-muted text-uppercase fs-8 ls-1'>
                ADMINISTRACIÓN
              </span>
            </div>
          </div>

          <AsideMenuItem to='/admin/reports' title='Reportes' hasBullet={true} />
          <AsideMenuItem to='/admin/stock' title='Inventario' hasBullet={true} />
        </>
      ) : (
        <>
          <div className='menu-item'>
            <div className='menu-content pt-8 pb-2'>
              <span className='menu-section text-black text-uppercase fs-2 ls-5'>MI ESTACIÓN</span>
            </div>
          </div>

          <OperatorStockPanel />
        </>
      )}
    </>
  )
}
